import React from 'react';
import styled from 'styled-components';

import responsive from '../utils/responsive';
import { H2, Paragraph } from './typography';

const TeamGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(6, 1fr);
  background: white;
  width: 100%;
  grid-gap: 2em;
  padding-top: 0;

  ${responsive.sm.andSmaller`
    grid-template-columns: repeat(2, 1fr);
    grid-template-rows: repeat(3, 1fr);
    > :nth-child(3) {
      grid-column: 1 / span 2;
      width: 50%;
      align-self: center;
      justify-self: center;
    }
  `}
`;

const Member = styled.img`
  width: 100%;
  border-radius: 50%;
  object-fit: cover;
  position: relative;

  :after {
    content: ' ';
    display: block;
    padding-bottom: 100%;
  }
`;

const Team = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  white-space: pre-line;

  > p {
    margin-bottom: 5em;
    text-align: left;
  }

  > h2 {
    text-align: center;
    margin-top: 0;
    font-style: italic;
  }
  padding: 4em 2em;
`;

const TeamSection = ({ about, title, members }) => (
  <Team>
    <H2>{title}</H2>
    <Paragraph>{about}</Paragraph>
    <TeamGrid>
      <div />
      <div />
      {members.map((img, i) => (
        <Member key={i} src={img} />
      ))}
    </TeamGrid>
  </Team>
);

export default TeamSection;
